import { Routes } from '@angular/router';

export const termsOfUseRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./terms-of-use.page').then((m) => m.TermsOfUsePage),
  },
];
